<template>
    <div id="rms-login" class="apply-bootstrap">
        <div class="container">
            <div class="row" id="rms-login-form">
                <div id="rmsLogo">
                    <img alt="RMS Login Page" src="../../rms/xsl/images/rmsLogo.png">
                </div>
                <div class="login-form-area">
                    <div class="rms-login-centered">
                        <h1>Recruiter Management System</h1>
                    </div>
                    <login-form c-id="loginForm" prop-user-type="rms" :prop-form-params="formParams"></login-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import "@common/syncfusionCss";
import { library } from "@common/library/library";
import { uStore } from "@common/userStore";

const rmsLoginCmp = {
    components: {
        loginForm: defineAsyncComponent(() => import('@common/loginForm/loginForm.vue'))
    },
    computed: {
        formParams() {
            return {
                hideInstanceList: true,
                showResetPwd: false,
                inlineLabel: false,
                copyrightContent: this.copyrightContent,
                clientSsoLabelAfterButton: false,
                clientSsoContactInformation: false,
                clientSsoButtonConfig: false
            };
        },
        copyrightContent() {
            return `
                <span>
                    Recruiter Management System (RMS) is a product and service of Samaritan.<br>
                    Copyright &copy; 2000 - ` + (new Date().getFullYear()) + ` Samaritan Software, LLC. All rights reserved world wide.
                </span>
            `;
        },
    },
    methods: {
        processAction: async function (act) {
            switch (act) {
                case 'login':
                    if (library.isFromLocalhost()) {
                        let localSid = library.getCookie('sds_localSid');
                        let loggedUser = await uStore().getLoggedUsers(['rms']);
                        if (localSid) {
                            location.href = PROJECTS_URL + 'rms/index.php?localhostDIS=' + localSid + '&localhostClientID=' + loggedUser;
                            return;
                        }
                        uStore().logout('rms');
                        return;
                    }
                    location.href = '../rms/index.php';
                    location.reload();
                    break;
            }
        },
    }
};

export default rmsLoginCmp;
</script>

<style lang="css">

body {
    background-color:#FFFFFF;
    margin:0
}

#rms-login .rms-login-centered {
    text-align: center;
    margin: 20px 0px 10px 0px;
}

#rms-login h1, #rms-login .h1 {
    color: #005C8F;
    font-family: 'Arial';
    font-size: 16pt;
    font-weight: bold;
}

#rmsLogo {
    margin: 0 auto;
    display: inline-block;
}

#rms-login button {
    text-transform: none !important;
}

#rms-login {
    text-align: center;
}

#rms-login .e-control-wrapper {
    border-bottom-width: 1px;
    border-bottom-color: #D4D4D4;
}

#rms-login .e-input {
    border-bottom-width: 0px;
    padding: 3px 5px;
}

#rms-login .custom-message-container {
    width: 100%;
}

#rms-login-form {
    width: 490px;
    max-width: 90%;
    margin: 0 auto;
    text-align: center;
    display: block;
}

#rms-login #buildInfo {
    text-align: center;
    color: #434343FF;
    font-family: Arial;
    font-size: 13px;
}

#rms-login .login-form-area {
    margin: 10px auto;
}

#rms-login .build-info {
    margin: 0 auto;
}

</style>
